
import { create } from "zustand";
import { getEarthWorkData } from "../api/earthWork";
import { getBannerData } from "../api/banner";
import { deleteProject, getProject, getProjectByID, getTotalProject, orderProjects, postProject, postProjectdata } from "../api/project";

export const useProjectStore = create((set, get) => ({
    loading: true,
    banner: null,
    project: [],
    projectCache: {},
    projectPage: null,
    totalProject: null,
    getBanner: async (pageName) => {
        try {
            set({ loading: true })
            const res = await getBannerData(pageName)
            set({ loading: false, banner: res })
            return res
        } catch (error) {
            console.log("Error in checkAuth:", error);
            return false;
        }
    },
    getProjectById: async (id) => {
        try {
            set({ loading: true })
            const res = await getProjectByID(id)
            set({ loading: false })
            return res
        } catch (error) {
            console.log("Error in checkAuth:", error);
            return false;
        }
    },
    getProjectForProjectPage: async (pageNumber, pageSize, search, field) => {
        try {
            set({ loading: true });
            const res = await getProject(pageNumber, pageSize, search, field);
            set({
                loading: false,
                project: res?.ref,
                projectPage: res?.project,
            });
            return res;
        } catch (error) {
            console.log("Error in getProjectForProjectPage:", error);
            return false;
        } finally {
            set({ isCheckingAuth: false, hasTriedAuth: true });
        }
    },
    postProject: async (formData, id) => {
        try {
            set({ loading: true });
            const res = await postProject(formData);
            set({
                loading: false,
            });
            return res;

        } catch (error) {
            console.log("Error in getProjectForProjectPage:", error);
            return false;
        }
    },
    deleteproduct: async (id) => {
        try {
            set({ loading: true })
            const res = await deleteProject(id)
            if (res) {
                const currentProject = get().project || [];
                const updatedProject = currentProject.filter((ele) => ele._id !== id);
                set({ loading: false, project: updatedProject });
            }
        } catch (err) {
            console.log("Internal server error:", err);
            set({ category: null });
            return false;
        }
    },
    postProjectPageData: async (form) => {
        try {
            set({ loading: true })
            const res = await postProjectdata(form)
            set({ loading: false })
        } catch (err) {
            console.log("Internal server error:", err);
            set({ category: null });
            return false;
        }
    },
    orderPrjectsFunction: async (form) => {
        try {
            set({ loading: true })
            const res = await orderProjects(form)
            set({ loading: false })
        } catch (err) {
            console.log("Internal server error:", err);
            set({ category: null });
            return false;
        }
    },
    gettotalproject: async () => {
        try {
            set({ loading: true })
            const res = await getTotalProject()
            console.log(res)
            set({ loading: false, totalProject: res })
            return res
        } catch (err) {
            console.log("Internal server error:", err);
            set({ category: null });
            return false;
        }
    },

}));
